'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
    // SameValue algorithm
    if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        // Added the nonzero y check to make Flow happy, but it is redundant
        return x !== 0 || y !== 0 || 1 / x === 1 / y;
    } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
    }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
    var ignoreKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (is(objA, objB)) {
        return true;
    }

    if ((typeof objA === 'undefined' ? 'undefined' : (0, _typeof3.default)(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : (0, _typeof3.default)(objB)) !== 'object' || objB === null) {
        return false;
    }

    var keysA = (0, _keys2.default)(objA);
    var keysB = (0, _keys2.default)(objB);

    if (keysA.length !== keysB.length) {
        return false;
    }

    // Test for A's keys different from B.
    for (var i = 0; i < keysA.length; i++) {
        if (ignoreKeys === null || !ignoreKeys[keysA[i]]) {
            if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
                return false;
            }
        }
    }

    return true;
}

var AbstractReactComponent = function (_React$Component) {
    (0, _inherits3.default)(AbstractReactComponent, _React$Component);

    function AbstractReactComponent(props) {
        (0, _classCallCheck3.default)(this, AbstractReactComponent);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AbstractReactComponent.__proto__ || (0, _getPrototypeOf2.default)(AbstractReactComponent)).call(this, props));

        _this.dispatch = null;

        if (props && props.dispatch) {
            _this.dispatch = props.dispatch;
        }
        return _this;
    }

    (0, _createClass3.default)(AbstractReactComponent, [{
        key: 'shouldComponentUpdateIgnore',
        value: function shouldComponentUpdateIgnore() {
            return null;
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return true;

            if (this.state !== nextState) {
                return true;
            }
            return !shallowEqual(this.props, nextProps, this.shouldComponentUpdateIgnore());
        }
    }]);
    return AbstractReactComponent;
}(_react2.default.Component);

exports.default = AbstractReactComponent;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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